/* ============================================
   BASE.JS — Premium Interactions & Animations
   ============================================ */

const isMobile = window.matchMedia('(hover: none), (max-width: 768px)').matches;

document.addEventListener('DOMContentLoaded', () => {
  initScrollReveal();
  initHeader();
  initSmoothScroll();
  if (!isMobile) {
    initParallax();
    initImageHover();
    initMagneticButtons();
    initBlurUpImages();
  }
  initCountUp();
  /* initPageTransitions(); — desktop page-transition overlay uitgeschakeld (terughalen: comment weghalen) */
  // initFreeShippingBar(); // uitgeschakeld: duplicaat van de Liquid-balk in main-cart, had hardcoded €75 + verkeerde valuta (€)
});

/* ============================================
   SCROLL REVEAL
   ============================================ */

function initScrollReveal() {
  const style = document.createElement('style');
  style.textContent = `
    .reveal,
    .reveal-left,
    .reveal-right,
    .reveal-scale {
      opacity: 0;
      transition: opacity 0.8s cubic-bezier(0.16, 1, 0.3, 1), transform 0.8s cubic-bezier(0.16, 1, 0.3, 1);
    }
    .reveal { transform: translateY(32px); }
    .reveal-left { transform: translateX(-40px); }
    .reveal-right { transform: translateX(40px); }
    .reveal-scale { transform: scale(0.94); }

    .reveal.revealed,
    .reveal-left.revealed,
    .reveal-right.revealed,
    .reveal-scale.revealed {
      opacity: 1;
      transform: none;
    }
  `;
  document.head.appendChild(style);

  const revealEls = document.querySelectorAll('.reveal, .reveal-left, .reveal-right, .reveal-scale');

  if (!revealEls.length) return;

  // On mobile reduce rootMargin so elements reveal sooner
  const margin = isMobile ? '0px 0px 0px 0px' : '0px 0px -60px 0px';

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const delay = parseInt(entry.target.dataset.delay) || 0;
        if (delay) entry.target.style.transitionDelay = `${delay}ms`;
        entry.target.classList.add('revealed');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: isMobile ? 0.05 : 0.12, rootMargin: margin });

  revealEls.forEach(el => observer.observe(el));

  // Failsafe: if IntersectionObserver never fires, reveal everything after 2.5s
  setTimeout(() => {
    document.querySelectorAll('.reveal:not(.revealed), .reveal-left:not(.revealed), .reveal-right:not(.revealed), .reveal-scale:not(.revealed)').forEach(el => {
      el.classList.add('revealed');
    });
  }, 2500);
}

/* ============================================
   PARALLAX (desktop only)
   ============================================ */

function initParallax() {
  const parallaxEls = document.querySelectorAll('[data-parallax]');
  if (!parallaxEls.length) return;

  let ticking = false;

  function updateParallax() {
    parallaxEls.forEach(el => {
      const speed = parseFloat(el.dataset.parallax) || 0.3;
      const rect = el.getBoundingClientRect();
      const centerY = rect.top + rect.height / 2 - window.innerHeight / 2;
      el.style.transform = `translateY(${centerY * speed}px)`;
    });
    ticking = false;
  }

  window.addEventListener('scroll', () => {
    if (!ticking) {
      requestAnimationFrame(updateParallax);
      ticking = true;
    }
  }, { passive: true });
}

/* ============================================
   HEADER SCROLL BEHAVIOUR
   ============================================ */

function initHeader() {
  const header = document.querySelector('.site-header');
  if (!header) return;

  let lastScroll = 0;

  window.addEventListener('scroll', () => {
    const currentScroll = window.scrollY;
    header.classList.toggle('scrolled', currentScroll > 20);

    // Hide on scroll-down, show on scroll-up — only on desktop
    if (!isMobile) {
      if (currentScroll > lastScroll && currentScroll > 200) {
        header.style.transform = 'translateY(-100%)';
      } else {
        header.style.transform = '';
      }
    }

    lastScroll = currentScroll;
  }, { passive: true });

  header.style.transition = 'transform 0.4s cubic-bezier(0.16, 1, 0.3, 1), box-shadow 0.3s ease';
}

/* ============================================
   SMOOTH SCROLL
   ============================================ */

function initSmoothScroll() {
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', (e) => {
      const target = document.querySelector(anchor.getAttribute('href'));
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
}

/* ============================================
   IMAGE HOVER TILT (desktop only)
   ============================================ */

function initImageHover() {
  document.querySelectorAll('.card-product').forEach(card => {
    card.addEventListener('mousemove', (e) => {
      const rect = card.getBoundingClientRect();
      const x = (e.clientX - rect.left) / rect.width - 0.5;
      const y = (e.clientY - rect.top) / rect.height - 0.5;
      card.style.transform = `perspective(1000px) rotateY(${x * 4}deg) rotateX(${-y * 4}deg) translateZ(8px)`;
    });
    card.addEventListener('mouseleave', () => {
      card.style.transform = '';
      card.style.transition = 'transform 0.5s cubic-bezier(0.16, 1, 0.3, 1)';
    });
    card.addEventListener('mouseenter', () => {
      card.style.transition = 'transform 0.1s ease';
    });
  });
}

/* ============================================
   COUNT UP ANIMATION
   ============================================ */

function initCountUp() {
  const counters = document.querySelectorAll('[data-count]');
  if (!counters.length) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      const el = entry.target;
      const target = parseInt(el.dataset.count);
      const suffix = el.dataset.suffix || '';
      const duration = 2000;
      const start = performance.now();

      function update(time) {
        const elapsed = time - start;
        const progress = Math.min(elapsed / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 3);
        el.textContent = Math.round(eased * target) + suffix;
        if (progress < 1) requestAnimationFrame(update);
      }

      requestAnimationFrame(update);
      observer.unobserve(el);
    });
  }, { threshold: 0.5 });

  counters.forEach(el => observer.observe(el));
}

/* ============================================
   CART INTERACTIONS
   ============================================ */

function addToCart(variantId, quantity = 1) {
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity })
  })
  .then(res => res.json())
  .then(() => {
    updateCartCount();
    showCartNotification();
  });
}

function updateCartCount() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      document.querySelectorAll('.cart-badge').forEach(el => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'inline-flex' : 'none';
      });
    });
}

function showCartNotification() {
  let notification = document.querySelector('.cart-notification');
  if (!notification) {
    notification = document.createElement('div');
    notification.classList.add('cart-notification');
    notification.innerHTML = `
      <span>Added to cart</span>
      <a href="/cart" class="cart-notification__link">View Cart →</a>
    `;
    document.body.appendChild(notification);

    const style = document.createElement('style');
    style.textContent = `
      .cart-notification {
        position: fixed;
        bottom: 1.5rem;
        right: 1.5rem;
        left: 1.5rem;
        background: var(--color-black);
        color: var(--color-white);
        padding: 1rem 1.25rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 1rem;
        font-size: 0.75rem;
        letter-spacing: 0.08em;
        text-transform: uppercase;
        z-index: 1000;
        transform: translateY(120%);
        transition: transform 0.4s cubic-bezier(0.16, 1, 0.3, 1);
        max-width: 420px;
        margin: 0 auto;
      }
      @media (min-width: 600px) {
        .cart-notification { left: auto; right: 2rem; bottom: 2rem; }
      }
      .cart-notification.visible { transform: translateY(0); }
      .cart-notification__link { border-bottom: 1px solid rgba(255,255,255,0.4); white-space: nowrap; }
    `;
    document.head.appendChild(style);
  }

  setTimeout(() => notification.classList.add('visible'), 10);
  setTimeout(() => notification.classList.remove('visible'), 3000);
}

/* ============================================
   PAGE TRANSITIONS (desktop only — skip on mobile)
   ============================================ */

function initPageTransitions() {
  // Skip on touch/mobile — 420ms delay feels broken on touch
  if (isMobile) return;

  const overlay = document.getElementById('page-transition');
  if (!overlay) return;

  const style = document.createElement('style');
  style.textContent = `
    #page-transition {
      position: fixed;
      inset: 0;
      background-color: var(--color-cream);
      z-index: 9998;
      pointer-events: none;
      opacity: 0;
      transform: scaleY(0);
      transform-origin: bottom;
      transition: transform 0.4s cubic-bezier(0.76, 0, 0.24, 1), opacity 0s 0.4s;
    }
    #page-transition.out {
      transform: scaleY(1);
      opacity: 1;
      transition: transform 0.4s cubic-bezier(0.76, 0, 0.24, 1), opacity 0s;
    }
    #page-transition.in {
      transform-origin: top;
      transform: scaleY(0);
      opacity: 1;
      transition: transform 0.4s cubic-bezier(0.76, 0, 0.24, 1) 0.05s;
    }
  `;
  document.head.appendChild(style);

  document.querySelectorAll('a').forEach(link => {
    if (
      link.hostname !== window.location.hostname ||
      link.href === window.location.href ||
      link.href.includes('#') ||
      link.target === '_blank' ||
      link.hasAttribute('data-no-transition')
    ) return;

    link.addEventListener('click', (e) => {
      e.preventDefault();
      const href = link.href;
      overlay.classList.add('out');
      setTimeout(() => { window.location = href; }, 420);
    });
  });

  window.addEventListener('pageshow', () => {
    overlay.classList.remove('out');
    overlay.classList.add('in');
    setTimeout(() => overlay.classList.remove('in'), 500);
  });
}

/* ============================================
   MAGNETIC BUTTONS (desktop only)
   ============================================ */

function initMagneticButtons() {
  document.querySelectorAll('.btn--primary, .btn--outline').forEach(btn => {
    btn.addEventListener('mousemove', (e) => {
      const rect = btn.getBoundingClientRect();
      const x = e.clientX - rect.left - rect.width / 2;
      const y = e.clientY - rect.top - rect.height / 2;
      btn.style.transform = `translate(${x * 0.2}px, ${y * 0.35}px)`;
      btn.style.transition = 'transform 0.1s ease';
    });
    btn.addEventListener('mouseleave', () => {
      btn.style.transform = '';
      btn.style.transition = 'transform 0.5s cubic-bezier(0.16, 1, 0.3, 1)';
    });
  });
}

/* ============================================
   BLUR-UP IMAGES (desktop only)
   ============================================ */

function initBlurUpImages() {
  const style = document.createElement('style');
  style.textContent = `
    img[loading="lazy"] {
      filter: blur(6px);
      transition: filter 0.5s ease;
    }
    img[loading="lazy"].loaded { filter: blur(0); }
  `;
  document.head.appendChild(style);

  document.querySelectorAll('img[loading="lazy"]').forEach(img => {
    if (img.complete) img.classList.add('loaded');
    else img.addEventListener('load', () => img.classList.add('loaded'));
  });
}

/* ============================================
   FREE SHIPPING PROGRESS BAR
   ============================================ */

function initFreeShippingBar() {
  const threshold = 7500;
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      const cartSummary = document.querySelector('.cart-summary');
      if (!cartSummary) return;

      const remaining = Math.max(0, threshold - cart.total_price);
      const progress = Math.min(100, (cart.total_price / threshold) * 100);

      const bar = document.createElement('div');
      bar.classList.add('shipping-bar');
      bar.innerHTML = `
        <p class="shipping-bar__text">
          ${remaining === 0
            ? '✓ You\'ve unlocked <strong>free shipping!</strong>'
            : `Add <strong>€${(remaining / 100).toFixed(2)}</strong> more for free shipping`
          }
        </p>
        <div class="shipping-bar__track">
          <div class="shipping-bar__fill" style="width: ${progress}%"></div>
        </div>
      `;
      cartSummary.insertBefore(bar, cartSummary.firstChild);

      const style = document.createElement('style');
      style.textContent = `
        .shipping-bar { margin-bottom: 1.5rem; }
        .shipping-bar__text { font-size: 0.8rem; color: var(--color-grey-dark); margin-bottom: 0.75rem; }
        .shipping-bar__text strong { color: var(--color-black); }
        .shipping-bar__track { height: 2px; background-color: var(--color-cream-dark); overflow: hidden; }
        .shipping-bar__fill { height: 100%; background-color: var(--color-black); transition: width 0.8s cubic-bezier(0.16, 1, 0.3, 1); }
      `;
      document.head.appendChild(style);
    });
}

